import { ILocaleConfig } from "@/config/locale.config";
import { LocaleToLabelMap, SupportedLocale } from "@/enums/locale.enum";

// Stage-specific locale configuration
const stageLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.EL,
    SupportedLocale.EN,
    SupportedLocale.RU,
    // SupportedLocale.FR,
    // SupportedLocale.AR,
    // SupportedLocale.ES,
  ],
  defaultLocale: SupportedLocale.EL,
  languageTabs: [
    {
      key: SupportedLocale.EL,
      label: LocaleToLabelMap.get(SupportedLocale.EL)!,
    },
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
    // { key: SupportedLocale.FR, label: LocaleToLabelMap.get(SupportedLocale.FR)! },
    // { key: SupportedLocale.AR, label: LocaleToLabelMap.get(SupportedLocale.AR)! },
    // { key: SupportedLocale.ES, label: LocaleToLabelMap.get(SupportedLocale.ES)! },
  ],
};

export default stageLocaleConfig;
